<div class="row">
  <div [ngClass]="tableTitleSizeClass" class="pt-2">
    <ng-content select=".cap-table-wrapper-title"></ng-content>
  </div>
  <div [ngClass]="tableSizeClass" class="pt-2">
    <ng-content select=".cap-table-wrapper-content"></ng-content>
  </div>
</div>
